import ja from './langs/ja'
import en from './langs/en'
import {initReactI18next} from "react-i18next";
import i18n from "i18next";

const availableLanguages = ['en', 'ja'];
i18n.use(initReactI18next)
   .init({
      resources: {
         en, ja,
      },
      lng: "ja",
      fallbackLng: "ja",
      debug: false,
      whitelist: availableLanguages,
      interpolation: {
         escapeValue: false
      }
   });

export default i18n;